import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ATS_ShortUrl.scss';
import { ATS_Fullstack, Button, ComponentSync, LL_H_C, LL_V_L, TS_AppTools } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ShortUrl } from '../../_entity/short-url/index.js';
import { Component_ShortUrlEditor } from './components/Component_ShortUrlEditor.js';
import { sortArray, voidFunction } from '@nu-art/ts-common';
import { TS_EditableItemController } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemController/index';
export class ATS_ShortUrl extends ComponentSync {
    static screen = {
        name: 'Short Url',
        key: 'short-url',
        renderer: this,
        modulesToAwait: [ModuleFE_ShortUrl],
        group: ATS_Fullstack
    };
    __onShortUrlsUpdated(...params) {
        this.forceUpdate();
    }
    render() {
        const allMutable = ModuleFE_ShortUrl.cache.allMutable();
        return _jsxs("div", { className: 'short-url', children: [_jsxs(LL_H_C, { className: 'page-title', children: [TS_AppTools.renderPageHeader('Manage App Short Urls'), _jsx(Button, { variant: 'primary', onClick: voidFunction, children: "Add Short Url" })] }), _jsxs(LL_V_L, { className: 'url-cards', children: [_jsx(Card_ShortUrl, {}, `new-short-url-${allMutable.length}`), sortArray(allMutable, (item) => item.title + item._shortUrl)
                            .map((shortUrl) => _jsx(Card_ShortUrl, { editorProps: { deleteCallback: () => this.forceUpdate() }, item: shortUrl }, shortUrl._id))] })] });
    }
}
class Card_ShortUrl extends TS_EditableItemController {
    static defaultProps = {
        module: ModuleFE_ShortUrl,
        editor: Component_ShortUrlEditor,
        createInitialInstance: () => ({})
    };
}
//# sourceMappingURL=ATS_ShortUrl.js.map